export const SAVE = 'RentalCarProtectionTravellerTugo.SAVE';
export const VALUE_CHANGED = 'RentalCarProtectionTravellerTugo.VALUE_CHANGED';
export const LOAD = 'RentalCarProtectionTravellerTugo.VALUE_LOAD';
export const NEXT = 'RentalCarProtectionTravellerTugo.NEXT';
export const RESET = 'RentalCarProtectionTravellerTugo.RESET';
export const RESET_FORM_STATE = 'RentalCarProtectionTravellerTugo.RESET_FORM_STATE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.RentalCarProtectionTraveller/constants.js